import { api } from '../../api/instance';

export const settingService = {
  getPushStatus() { return api.get('v3/settings/push_sent'); },
  postAppReview(reviewInfo) { return api.post('v3/settings/app_review', { review_info: reviewInfo || {} }); },
};



// WEBPACK FOOTER //
// ./app/javascript/website_newgen/js/stores/settingStore/service.js